import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/fc/bg.png';
import _imports_1 from '@/assets/componentImg/fc/btn.png';

const _withScopeId = n => (_pushScopeId("data-v-4e4d588c"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_0
}, null, -1));

const _hoisted_2 = ["username", "path"];

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = ["username", "path"];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = ["username", "path"];

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));

const _hoisted_10 = [_hoisted_9];
import composition from '@/composition';
import ua from '@/utils/platform';
import { gotByRoute, closeWebView } from '@/utils/app';
import { onMounted } from 'vue';
export default {
  setup(__props) {
    const {
      store,
      wxShare,
      ref
    } = composition();
    var newstitle = '请打开佛山+预览';
    var newsdesc = '更多精彩请下载佛山+';
    wxShare(newstitle, newsdesc);
    store.dispatch('_initApp');
    const appIdMap = {
      fireworks: '648810b4eb76cc000153b2fe',
      deputy: '649e37b7eb76cc000153b363',
      match: '64dad1a5eb76cc000153b4b1'
    };
    const isWeixin = ref(false);
    const isweapp = ref(false);
    const wx_username = ref('gh_c0321ea144e0');
    const wx_path = ref('/packageNews/pages/index/index');
    const isFirewords = ref(false);
    const isMatch = ref(false);
    const wx_match_path = ref('');
    const wx_match_username = ref('gh_adf18914ea42');
    const wx_fireworks_username = ref('gh_266a7d093caf');
    const wx_fireworks_path = ref('/packageMap/pages/home/home');
    onMounted(() => {
      setTimeout(() => {
        isWeixin.value = ua.isWeixin;

        if (window.location.href.includes('match.html')) {
          isMatch.value = true;
          let payUrl = getQueryString('payUrl');

          if (payUrl) {
            localStorage.setItem('fc-match-auto', 1);
            payUrl = decodeURIComponent(payUrl);
            payUrl = payUrl + `&redirect_url=${encodeURIComponent('https://content.foshanplus.com/fs-web-1/foshan-street/match.html?auto=1')}`; // 去支付了

            window.location.href = payUrl;
          } else {
            let auto = getQueryString('auto');

            if (auto == 1) {
              setTimeout(() => {
                if (store.state.isApp) {
                  if (ua.isIOS) {
                    gotByRoute(`miniProgram://fc?appId=64dad1a5eb76cc000153b4b1&singleTask=false&needX5=true`);
                    closeWebView();
                  } else if (ua.isAndroid) {
                    _Dialog.alert({
                      title: '提示',
                      message: '返回相亲平台',
                      showCancelButton: false,
                      confirmButtonColor: '#333'
                    }).then(() => {
                      // on close
                      gotByRoute(`miniProgram://fc?appId=64dad1a5eb76cc000153b4b1&singleTask=false&needX5=true`);
                      closeWebView();
                    });
                  }
                } else {
                  let url = '';

                  if (ua.isIOS) {
                    url = encodeURIComponent(`miniProgram://fc?appId=64dad1a5eb76cc000153b4b1&singleTask=false&needX5=true`);
                    window.location.href = `https://vip.foshanplus.com/app/download.html?route=${url}`;
                  } else {
                    url = encodeURIComponent(`miniProgram://fc?appId=64dad1a5eb76cc000153b4b1&singleTask=false&needX5=true`);
                    window.location.href = `https://content.foshanplus.com/download.html?route=${url}`;
                  }
                }
              }, 1000);
              return;
            }

            let memberId = getQueryString('memberId');
            let billNo = getQueryString('billNo');
            let enrollmentDetailId = getQueryString('enrollmentDetailId');

            if (memberId && billNo && enrollmentDetailId) {
              wx_match_path.value = `/packageMatch/pages/verifyCode/verifyCode?memberId=${memberId}&billNo=${billNo}&enrollmentDetailId=${enrollmentDetailId}`; // if (store.state.isApp) {
              // let detailPath = `&path=packageMatch%2Fpages%2FverifyCode%2FverifyCode&query=memberId%3D${memberId}%26billNo%3D${billNo}%26enrollmentDetailId%3D${enrollmentDetailId}`
              // wx_match_path.value = `/packageMatch/pages/verifyCode/verifyCode?memberId=${memberId}&billNo=${billNo}&enrollmentDetailId=${enrollmentDetailId}`
              // gotByRoute(`miniProgram://fc?appId=64dad1a5eb76cc000153b4b1${detailPath}&singleTask=false&needX5=true`)
              // closeWebView()
              // return
              // }
              // return
            }
          }
        }

        if (window.location.href.includes('fsplus.html')) {
          isweapp.value = true;
          wx_username.value = 'gh_c0321ea144e0';
          wx_path.value = '/packageNews/pages/index/index'; // 保底跳首页

          let action = getQueryString('action');

          if (action == 'boke') {
            const url = getQueryString('url');
            url && (wx_path.value = decodeURIComponent(url));
          }
        }

        if (window.location.href.includes('fireworks.html')) {
          const id = getQueryString('id'); // 是烟火的

          if (id) {
            // 去详情的
            wx_fireworks_path.value = `/packageMap/pages/detail/detail?id=${id}`;
          }

          isFirewords.value = true;
        }
      }, 500);
    });

    function goApp() {
      if (store.state.isApp) {
        // app 环境直接关闭
        closeWebView();
        return;
      } // h5 专用的方法


      let appName = '';
      let detailPath = '';
      let id = getQueryString('id');

      if (window.location.href.includes('fireworks.html')) {
        appName = 'fireworks';

        if (id) {
          detailPath = `&path=packageMap%2Fpages%2Fdetail%2Fdetail&query=id%3D${id}`;
        } else {
          detailPath = `&path=packageMap%2Fpages%2Fhome%2Fhome`;
        }
      } else if (window.location.href.includes('deputy.html')) {
        appName = 'deputy';

        if (id) {
          detailPath = `&path=packageHelp%2Fpages%2Fdetail%2Fdetail&query=id%3D${id}`;
        } else {
          detailPath = `&path=packageHelp%2Fpages%2Findex%2Findex`;
        }
      } else if (window.location.href.includes('match.html')) {
        appName = 'match';
        let code = getQueryString('actcode'); // 活动详情 带参数code

        let payUrl = getQueryString('payUrl'); // 嘉宾详情 带用户id

        let page = getQueryString('page'); // 通用其他页面 不带参数

        if (id) {
          detailPath = `&path=packageMatch%2Fpages%2Fdetail%2Fdetail&query=id%3D${id}`;
        } else if (code) {
          detailPath = `&path=packageMatch%2Fpages%2FactivityDetail%2FactivityDetail&query=code%3D${code}`;
        } else if (payUrl) {
          payUrl = decodeURIComponent(payUrl);
          payUrl = payUrl + `&redirect_url=${encodeURIComponent('https://content.foshanplus.com/fs-web-1/foshan-street/match.html')}`;
          window.location.href = decodeURIComponent(payUrl);
          return;
        } else if (page) {
          detailPath = `&path=${page}`;
        } else {
          detailPath = `&path=packageMatch%2Fpages%2FnewIndex%2FnewIndex`;
        }
      }

      let appId = appIdMap[appName];
      let url = '';

      if (ua.isIOS) {
        url = encodeURIComponent(`miniProgram://fc?appId=${appId}${detailPath}&singleTask=false&needX5=true`);
        window.location.href = `https://vip.foshanplus.com/app/download.html?route=${url}`;
      } else {
        url = encodeURIComponent(`miniProgram://fc?appId=${appId}${detailPath}&singleTask=false&needX5=true`);
        window.location.href = `https://content.foshanplus.com/download.html?route=${url}`;
      } // console.log(url)

    }

    function getQueryString(name) {
      const url_string = window.location.href;
      const url = new URL(url_string);
      return url.searchParams.get(name);
    }

    return (_ctx, _cache) => {
      const _directive_wx_weapp = _resolveDirective("wx-weapp");

      return _openBlock(), _createElementBlock("div", null, [_hoisted_1, isWeixin.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [isweapp.value ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "btn",
        username: wx_username.value,
        path: wx_path.value
      }, _hoisted_4, 8, _hoisted_2)), [[_directive_wx_weapp]]) : _createCommentVNode("", true), isFirewords.value ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "btn fireworks",
        username: wx_fireworks_username.value,
        path: wx_fireworks_path.value
      }, _hoisted_7, 8, _hoisted_5)), [[_directive_wx_weapp]]) : _createCommentVNode("", true), isMatch.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [wx_match_path.value ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "btn fireworks",
        username: wx_match_username.value,
        path: wx_match_path.value
      }, _hoisted_10, 8, _hoisted_8)), [[_directive_wx_weapp]]) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        id: "goApp",
        class: "btn",
        src: _imports_1,
        onClick: goApp
      }))], 64)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        id: "goApp",
        class: "btn",
        src: _imports_1,
        onClick: goApp
      }))]);
    };
  }

};